import { render } from "./ContentBlock.vue?vue&type=template&id=24584efe&scoped=true"
import script from "./ContentBlock.vue?vue&type=script&lang=js"
export * from "./ContentBlock.vue?vue&type=script&lang=js"

import "./ContentBlock.vue?vue&type=style&index=0&id=24584efe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24584efe"]])

export default __exports__